"use strict";
exports.__esModule = true;
var pageopt = {
    urlkeyvalues: {
        pagenumber: "pageNumber",
        pagesize: "pageSize",
        sortname: "sortColumns",
        sortorder: "sortTypes"
    },
    columns: {}
};
window.pageopt = pageopt;
exports["default"] = pageopt;
